// Dates from the API are plain YYYY-MM-DD (listing-local calendar days) —
// never pass them through `new Date(str)`, which would shift them by the
// device timezone.
export function parseDay(value: string): Date {
  const [y, m, d] = value.split('-').map(Number);
  return new Date(y, m - 1, d);
}

export function toDay(date: Date): string {
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${date.getFullYear()}-${m}-${d}`;
}

export function addDays(value: string, days: number): string {
  const date = parseDay(value);
  date.setDate(date.getDate() + days);
  return toDay(date);
}

export function today(): string {
  return toDay(new Date());
}

export function nightsBetween(start: string, end: string): number {
  return Math.round((parseDay(end).getTime() - parseDay(start).getTime()) / 86400000);
}

export function formatDay(value: string, locale: string, opts: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'short' }) {
  return parseDay(value).toLocaleDateString(locale, opts);
}

export function formatRange(start: string, end: string, locale: string) {
  return `${formatDay(start, locale)} — ${formatDay(end, locale, { day: 'numeric', month: 'short', year: 'numeric' })}`;
}

export function formatDateTime(iso: string, locale: string) {
  return new Date(iso).toLocaleString(locale, { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
}
